import { keyframes } from "@emotion/react";

import { greyDarkRGB } from "@/angelouCE/utils/constants";

const baseColor = `rgba(${greyDarkRGB}, .05)`;
const highlightColor = `rgba(${greyDarkRGB}, .10)`;
const animationDuration = "2s";

const loadingAnimation = keyframes`
    0% {
      background-color: ${baseColor};
    },
    50% {
      background-color: ${highlightColor};
    },
    100% {
      background-color: ${baseColor};
    }
`;

export const skeletonWrapperCss = {
  width: "100%",

  // Prevent skeleton from shrinking when parent has `display: flex`
  '[aria-live="polite"]': {
    width: "100%",
  },
};

export const skeletonCss = {
  width: "100%",
  borderRadius: "0.5rem",
  display: "inline-flex",
  lineHeight: "1",
  animation: `${loadingAnimation} ${animationDuration} ease-in-out infinite`,
  animationDelay: "250ms",
};
